export const environment = {
  deployed: process.env.MODE === "production",
};
